import React, { useState, useEffect } from "react";
import Header from "../layout/Header";
import swal from "sweetalert";
import { customerView, transactionRegistration, updateCustomerReceiptData, getCustomerReceiptData } from "../pages/campaigns/services";

const Activity = () => {
    const [loader, setLoader] = useState(false);
    const [receiptList, setReceiptList] = useState([]);

    useEffect(() => {
        getReceiptDetails();
    }, []);

    const getReceiptDetails = async () => {
        setLoader(true);
        let tempToken = JSON.parse(localStorage.getItem("token_gen"));
        const res = await getCustomerReceiptData(tempToken?.access_token);
        if (res.message === "Success") {
            setReceiptList(res?.data);
        }
        setLoader(false);
    };

    const updateReceiptDetails = async (token, body) => {
        const res = await updateCustomerReceiptData(token, body)
        if (res.message === "Success") {
            await getReceiptDetails()
            swal({
                position: "center",
                icon: "success",
                title: "Request processed successfully.",
                showConfirmButton: false,
                timer: 2000,
            });
        } else {
            swal({
                position: "center",
                icon: "error",
                title: res.message,
                showConfirmButton: false,
                timer: 2000,
            });
        }
    }

    const onSubmit = async (receipt, status) => {
        const { updatedAt, _attachments, _etag, _rid, _self, _ts, ...rest } = receipt
        setLoader(true)
        const body = {
            ...rest, other1: {
                ...rest.other1,
                status: status
            }
        }

        const amount = rest?.productData.reduce((sum, item) => sum + (item.cashback || 0), 0);

        let tempToken = JSON.parse(localStorage.getItem("token_gen"));
        const custRes = await customerView(tempToken?.access_token, receipt.customercode)

        const transBody = {
            activityType: "signup",
            mobile: custRes.customer.mobile,
            schemacode: "TSC002028"
        }
        if (status === 1) {
            const transactionReg = await transactionRegistration(tempToken?.access_token, JSON.stringify(transBody));
            if (transactionReg?.message === "Request processed successfully.") {
                await updateReceiptDetails(tempToken?.access_token, body)
            } else {
                swal({
                    position: "center",
                    icon: "error",
                    title: transactionReg.message,
                    showConfirmButton: false,
                    timer: 2000,
                });
            }
        } else {
            await updateReceiptDetails(tempToken?.access_token, body)
        }

        setLoader(false)
    };

    return (
        <>
            {loader && (
                <div className="mainPreloaderMain">
                    <div className="mainPreloader">
                        <div></div><div></div><div></div><div></div>
                        <div></div><div></div><div></div><div></div>
                    </div>
                </div>
            )}

            <Header name={"Customer Activity Details"} />

            <div className="dashboard__content">
                <div className="container-fluid">
                    <div className="dashboard__customersCard">
                        <div className="dashboard__header">
                            <div className="dashboard__left">
                                <h4>Customer Activity Details</h4>
                            </div>
                        </div>

                        <div className="receipt__body">
                            {receiptList?.length ? (
                                <div className="receipt-box-wrapper">
                                    {receiptList.map((receipt, i) => (
                                        <div key={i} className="image-action-box">
                                            <div className="image-box">
                                                {receipt?.other1 ? (
                                                    <div className="receipt-image-container">
                                                        <a
                                                            href={receipt?.other1?.imageLink}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                        >
                                                            {/\.(mp4|webm|ogg|mov|mkv)$/i.test(receipt?.other1?.imageLink) ? (
                                                                <video
                                                                    src={receipt?.other1?.imageLink}
                                                                    controls
                                                                    className="receipt-video"
                                                                    style={{
                                                                        width: "100%",
                                                                        maxWidth: "250px",
                                                                        borderRadius: "10px",
                                                                        border: "1px solid #ddd",
                                                                        objectFit: "contain",
                                                                    }}
                                                                >
                                                                    Your browser does not support the video tag.
                                                                </video>
                                                            ) : (
                                                                <img
                                                                    src={receipt?.other1?.imageLink}
                                                                    alt="Activity"
                                                                    className="receipt-image"
                                                                />
                                                            )}
                                                        </a>
                                                    </div>
                                                ) : (
                                                    <p>No image available.</p>
                                                )}
                                            </div>

                                            {receipt?.other1.status === 0 && (
                                                <div className="action-buttons">
                                                    <button
                                                        className="btn btn-success"
                                                        onClick={() => onSubmit(receipt, 1)}
                                                    >
                                                        ✅ Accept
                                                    </button>
                                                    <button
                                                        className="btn btn-danger"
                                                        onClick={() => onSubmit(receipt, 2)}
                                                    >
                                                        ❌ Reject
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <div className="no-data">No record found</div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>

    );
};

export default Activity;
